
import { icons } from '../../assets';
import './pageloader.scss';

const PageLoader = () => {
  return (
    <div className="page-loader">
      <img src={icons.loader} alt="Loading..." />
    </div>
  )
};

export default PageLoader;
